import './ErrorPage.css';
import React from 'react';
import { Stack } from '../../components/Stack/Stack';
import { Icon } from '../../components/Icon/Icon';
import { Gatekeeper } from '../Gatekeeper/Gatekeeper';

interface Props {
  error: Error;
  action?: JSX.Element;
  simple?: boolean;
}

export function ErrorPage({ error, action, simple }: Props): JSX.Element {
  if (simple) {
    return (
      <div className="container">
        <h1>{error.message}</h1>
      </div>
    );
  }

  return (
    <Gatekeeper>
      <Stack size="lg" justify="center">
        <Icon name="close" className="error-page__invalid" />
        <strong className="error-page__message">{error.message}</strong>
        <div />
        {action && <footer className="error-page__footer">{action}</footer>}
      </Stack>
    </Gatekeeper>
  );
}
